import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const blocks = document.querySelectorAll('.block-section.konferanse-info.has-slider');

if (blocks.length) {
	blocks.forEach((block) => {
		const swiperEl = block.querySelector('.konferanse-info__swiper');

		if (!swiperEl) {
			return;
		}

		new Swiper(swiperEl, {
			modules: [Navigation, Pagination],
			slidesPerView: 1.12,
			spaceBetween: 16,
			loop: false,
			navigation: {
				prevEl: block.querySelector('.konferanse-info__slider-prev'),
				nextEl: block.querySelector('.konferanse-info__slider-next'),
			},
			pagination: {
				el: block.querySelector('.konferanse-info__slider-progress'),
				type: 'progressbar',
			},
			breakpoints: {
				640: {
					slidesPerView: 1.15,
					spaceBetween: 20,
				},
				1024: {
					slidesPerView: 1.18,
					spaceBetween: 24,
				},
			},
		});
	});
}
